module.exports = __webpack_public_path__ + "static/media/logo.174c4e6e.png";